// frontend/src/components/mediaCroperModal.js

import React from "react";
import { createPortal } from "react-dom";
import { X } from "phosphor-react";
import Cropper from "react-easy-crop";

export default function MediaCropperModal({
  open,
  image,
  crop,
  zoom,
  aspect,
  cropPixels,
  onCropChange,
  onZoomChange,
  onCropComplete,
  onAspectChange,
  onCancel,
  onApply,
}) {
  if (!open || typeof document === "undefined") {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 z-[999999] flex items-center justify-center overflow-y-auto bg-black/40 px-4 py-6">
      <div className="w-full max-w-md space-y-4 rounded-2xl bg-white p-4 shadow-xl sm:p-6">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold">
            Crop Media
          </h3>

          <button
            type="button"
            onClick={onCancel}
            className="flex h-8 w-8 items-center justify-center rounded-full text-gray-500 transition hover:bg-gray-100 hover:text-gray-700"
            aria-label="Close cropper"
          >
            <X size={18} weight="bold" />
          </button>
        </div>

        <div className="flex gap-2 text-xs">
          <button
            type="button"
            className={[
              "rounded-full border !min-h-0 !min-w-0 px-2.5 py-1",
              aspect === 1
                ? "border-blue-600 bg-blue-600 text-white"
                : "border-gray-300",
            ].join(" ")}
            onClick={() => onAspectChange(1)}
          >
            1:1
          </button>

          <button
            type="button"
            className={[
              "rounded-full border !min-h-0 !min-w-0 px-2.5 py-1",
              aspect === 4 / 5
                ? "border-blue-600 bg-blue-600 text-white"
                : "border-gray-300",
            ].join(" ")}
            onClick={() => onAspectChange(4 / 5)}
          >
            4:5
          </button>

          <button
            type="button"
            className={[
              "rounded-full border !min-h-0 !min-w-0 px-2.5 py-1",
              aspect === 16 / 9
                ? "border-blue-600 bg-blue-600 text-white"
                : "border-gray-300",
            ].join(" ")}
            onClick={() => onAspectChange(16 / 9)}
          >
            16:9
          </button>
        </div>

        <div className="relative h-[320px] w-full overflow-hidden rounded-lg bg-black/5 sm:h-[390px]">
          <Cropper
            image={image}
            crop={crop}
            zoom={zoom}
            aspect={aspect}
            showGrid={false}
            restrictPosition
            onCropChange={onCropChange}
            onZoomChange={onZoomChange}
            onCropComplete={onCropComplete}
          />
        </div>

        <div className="flex items-center gap-3">
          <label
            htmlFor="crop-zoom"
            className="shrink-0 text-sm text-gray-600"
          >
            Zoom
          </label>

          <input
            id="crop-zoom"
            type="range"
            min={1}
            max={3}
            step={0.01}
            value={zoom}
            onChange={(e) => onZoomChange(Number(e.target.value))}
            className="w-full"
          />
        </div>

        <div className="flex justify-end gap-2">
          <button
            type="button"
            className="rounded-full bg-gray-100 px-3 py-2 text-sm font-medium !min-h-0 !min-w-0 hover:ring-2 hover:ring-gray-300"
            onClick={onCancel}
          >
            Skip
          </button>

          <button
            type="button"
            className="rounded-full bg-blue-600 px-3 py-2 text-sm font-medium text-white !min-h-0 !min-w-0 hover:ring-2 hover:ring-blue-300 disabled:cursor-not-allowed disabled:opacity-50"
            onClick={onApply}
            disabled={!cropPixels}
          >
            Use cropped
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}